import React from 'react';

import {
  Box,
  styled,
  Typography
} from '@mui/material';
import { ActorStageName } from 'generated/graphql';
import _ from 'lodash';
import { PopupMenu } from 'modules';

import * as types from '../../types';



const RootBox = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  padding: '12px 16px',
  height: 68,
  alignItems: 'center',
  borderRadius: 10,
  backgroundColor: '#F0F7FA'
});

const TitleTypography = styled(Typography)({
  fontWeight: 700
});



interface ICreateInvestorArgs {
  stageName: ActorStageName;
  displayName: string;
  investorId: string;
}

interface IProps {
  stages: types.IStage[];
  favoritedInvestor: types.IFavoritedInvestor;
  onClickCreateInvestorCard: (args: ICreateInvestorArgs) => void;
}

export const FC: React.FC<IProps> = props => {
  const stageOptions = React.useMemo(() => {
    const allStagesExcludingFavorites = _.filter(props.stages, s => s.name !== 'favorites');

    return _.map(allStagesExcludingFavorites, (s): PopupMenu.IActionOption => ({
      type: 'action',
      label: s.displayName,
      fnAction: async () => {
        props.onClickCreateInvestorCard({
          stageName: s.name,
          displayName: props.favoritedInvestor.companyName,
          investorId: props.favoritedInvestor.investorId
        });
      }
    }));

  }, [props]);



  const options = React.useMemo((): PopupMenu.IMenuOption[] => [
    {
      type: 'nestedOptions',
      label: 'Move to column',
      options: stageOptions
    }

  ], [stageOptions]);




  return (
    <RootBox>
      <TitleTypography>
        {props.favoritedInvestor.companyName}
      </TitleTypography>

      <Box>
        <PopupMenu.FC options={options} />
      </Box>
    </RootBox>
  );
};
